module.exports = __webpack_public_path__ + "img/Cursos todos los meses.9bba83e2.svg";